import * as React from "react";
import { Book } from "../../../types/Book";
import "./Card.css";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Done";
import TimeIcon from "@material-ui/icons/Schedule";
import cn from "classnames";

interface Props {
	book: Book;
	dummy?: boolean;
	moreText?: string;
	toBookPage?: boolean;
	fullWidth?: boolean;
	date?: string;
	flatCategory?: boolean;
	hiddenCheckIcon?: boolean;
}

const Card: React.FC<Props> = ({
	book,
	dummy,
	moreText,
	toBookPage,
	fullWidth,
	date,
	flatCategory,
	hiddenCheckIcon,
}) => {
	/*const link = book.card?.id && !toBookPage
			? `/books/#/${book.card.id}`
			: book.woo_id
			? `/book/${book.woo_id}/`
			: null;*/

	const link = `/book/${book.woo_id}/`;

	return (
		<>
			<a
				className={cn("feed-card", {
					"feed-card_dummy": dummy,
					"feed-card_fullWidth": fullWidth,
				})}
				href={link}
			>
				<div className="feed-card-thumb">
					<div
						className="feed-card-thumb__blured-image"
						style={{ backgroundImage: `url(${book.image})` }}
					/>

					<div
						className="feed-card-thumb__image"
						style={{ backgroundImage: `url(${book.image})` }}
					/>

					<div
						className="feed-card-thumb__description"
						dangerouslySetInnerHTML={{
							__html: book.description,
						}}
					/>

					<div
						className={cn("feed-card-thumb__payload", {
							"feed-card-thumb__payload_flat": flatCategory,
						})}
					>
						{book.collection && (
							<div className="feed-card-thumb__payload__item">
								{book.collection.name}
							</div>
						)}
					</div>

					{date && (
						<div className="feed-card-thumb__date">
							<TimeIcon />
							{date}
						</div>
					)}
				</div>

				<div className="feed-card-desc">
					<div
						className={cn("feed-card-add", {
							"feed-card-add_added": book.card?.id,
							"feed-card-add_more": moreText,
							"feed-card-add_hidden": hiddenCheckIcon,
						})}
					>
						{book.card?.id ? moreText ? moreText : <CheckIcon /> : <AddIcon />}
					</div>

					<div className="feed-card-desc__author">{book.author}</div>

					<div className="feed-card-desc__name">{book.name}</div>
				</div>
			</a>
		</>
	);
};

export default Card;
